/** Module-level Map tracking live Input component values for form submission collection.
 *  Bypasses React state intentionally — no component re-renders on change. */
export const liveInputValues = new Map<string, unknown>();

/** Companion metadata map — stores fieldName/label for each input so the
 *  submit handler can auto-map inputs to schema fields without a store lookup. */
export const liveInputMeta = new Map<string, { fieldName?: string; name?: string; label?: string }>();
